import React, { useState, useEffect } from 'react';
import {
  Button,
  Grid,
  Column,
  DataTable,
  DatePicker,
  DatePickerInput,
  Modal,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  TableToolbar,
  TableToolbarContent,
  TableToolbarSearch,
  Pagination,
  RadioButton,
  RadioButtonGroup,
  Theme,
} from 'carbon-components-react';
import { getOperationsList } from '../../services/services';
import { useNavigate } from "react-router-dom";
import CommodityHeader from '../../components/Header';

const headers = [
  {
    key: 'ctrycode',
    header: 'Country',
  },
  {
    key: 'compcode',
    header: 'Company',
  },
  {
    key: 'invonumb',
    header: 'Invonumb',
  },
  {
    key: 'action',
    header: 'Action',
  },
  {
    key: 'description',
    header: 'Description',
  },
  {
    key: 'user',
    header: 'User',
  },
  {
    key: 'date',
    header: 'Date',
  },
  {
    key: 'hour',
    header: 'Hour',
  }
];


const OperationsLog = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [rows, setRows] = useState([]);
  const [allRegisters, setAllRegisters] = useState([]);
  const [errors, setErrors] = useState([]);
  const [dateModal, setDateModal] = useState(false);
  const [initDate, setInitDate] = useState();
  const [endDate, setEndDate] = useState();
  const [onlyErrors, setOnlyErrors] = useState(false);
  const todaysDate = new Date();

  const changePaginationState = (pageInfo) => {
    if (page !== pageInfo.page) {
      setPage(pageInfo.page)
    }
    if (pageSize !== pageInfo.pageSize) {
      setPageSize(pageInfo.pageSize)
    }
  }

  const getOperations = async (request) => await getOperationsList(request)
  .then(response => {
    if(response.status === 200){
      response.json()
        .then(response => {
          parserIdInResponse(response);
        })
    }    
  });       

  const parserIdInResponse = (response) => {
    if (response.logIAS.length === 0) {
        window.alert("There are no logs registered for the current month.\nPlease, choose a date")
    } else {
      const resParsed = response.logIAS.map((res, i) => {
        const parsed = {};
        parsed["id"] = "" + i;
        parsed["ctrycode"] = res.ctrycode;
        parsed["compcode"] = res.compcode;
        parsed["invonumb"] = res.invonum;
        parsed["action"] = res.action;
        parsed["description"] = res.description;
        parsed["user"] = res.user;
        parsed["date"] = res.date;
        parsed["hour"] = res.hour;
        return parsed;
      });
      setAllRegisters(resParsed);
      setRows(resParsed);
      const resErrors = response.logIASErrors.map((res, i) => {
        const parsed = {};
        parsed["id"] = "" + i;
        parsed["ctrycode"] = res.ctrycode;
        parsed["compcode"] = res.compcode;
        parsed["invonumb"] = res.invonum;
        parsed["action"] = res.action;
        parsed["description"] = res.description;
        parsed["user"] = res.user;
        parsed["date"] = res.date;
        parsed["hour"] = res.hour;
        return parsed;
      });
      setErrors(resErrors);
    }
   
  };
  function closeModal() {
    setDateModal(false);
  };

  const goHomeScreen = () => {
    navigate('/home')
  };

  function openModal() {
    setDateModal(true);
  };

  function loadTable(type) {
    if (type === "ALL") {
      setOnlyErrors(false);
      setRows(allRegisters);
    } else if (type === "ERR") {
      setOnlyErrors(true);
      setRows(errors);
    }
  };


  function handleDatePicker(dates) {
    const [rangeStart, rangeEnd] = dates;
    setInitDate(new Date(rangeStart).toISOString().slice(0, 10).replaceAll("-", "/"));
    if (rangeEnd !== undefined) {
      setEndDate(new Date(rangeEnd).toISOString().slice(0, 10).replaceAll("-", "/"));
    };
  };

  function cleanDescription(desc) {
    let ret = desc.replaceAll("<p>", "");
    ret = ret.replaceAll("<b>", "");
    ret = ret.replaceAll("</p>", "\n\n");
    ret = ret.replaceAll("</b>", "")
    ret = ret.slice(0, ret.length-2);
    return ret;
  };

  function submitSearchByDate() {

    let request = {};
    request.option = 'fecha';
    request.fromDate = getDateFormated(new Date(initDate));
    request.toDate = getDateFormated(new Date(endDate));    

    getOperations(request);
    closeModal();
  };

  const getDateFormated = (date) =>{
    let dd = String(date.getDate()).padStart(2, '0');
    let mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = date.getFullYear();

    return  dd+ '/' + mm + '/' + yyyy;
  }

  const substractDays = (date, daysToSubstract) => {      
    let newDate = new Date();
    newDate.setDate(date.getDate() - daysToSubstract);    
    return newDate;
  }

  useEffect(() => {
    let request = {};
    request.option = '';
    request.fromDate = getDateFormated(substractDays(todaysDate,3));    
    request.toDate = getDateFormated(todaysDate)
    getOperations(request);    
  }, [0])

  return (
    <>
      <h2 className="table-title">Log End User Operations</h2>
      <Theme theme="g90">
          <CommodityHeader />
        </Theme>
      <Grid>
        <Modal
          className="selectDate-Modal"
          focusTrap={false}
          hasscrollingcontent="false"
          iconDescription="Close the modal"
          aria-label="SelectDate modal"
          modalAriaLabel="Select Date modal"
          onBlur={function noRefCheck() { }}
          onClick={function noRefCheck() { }}
          onFocus={function noRefCheck() { }}
          onKeyDown={function noRefCheck() { }}
          onRequestClose={closeModal}
          onRequestSubmit={() => submitSearchByDate()}
          onSecondarySubmit={closeModal}
          open={dateModal}
          passiveModal={false}
          primaryButtonDisabled={false}
          primaryButtonText="Submit"
          secondaryButtonText="Back"
          selectorPrimaryFocus="[data-modal-primary-focus]"
          modalHeading={<h3>Search by date</h3>}
        >
          {<p><strong>Search Operations Logs by picking an initial and final date</strong></p>}
          <Grid>
            <Column lg={16}>

              <TableHeader >
                <h5 className="select-header-modal"> Date</h5>
              </TableHeader>
              <DatePicker
                className="style_date_picker"
                id="date-picker"
                datePickerType="range"
                onChange={(e) => handleDatePicker(e)}
                value={""}
                dateFormat="d/m/Y"
                maxDate={todaysDate.toLocaleDateString()}
              >
                <DatePickerInput
                  id="date-picker-input-id-start"
                  labelText="Init Date"
                />
                <DatePickerInput
                  id="date-picker-input-id-end"
                  labelText="End Date"
                />
              </DatePicker>
            </Column>
          </Grid>

        </Modal >
      </Grid >
      <Grid>
        <Column lg={16}>
        <Button className='style-bttbackID' size="lg" style={{marginBottom: '20px'}} onClick={goHomeScreen}>Back to Home</Button>          
          <DataTable
            isSortable="true"
            rows={rows}
            headers={headers}
            render={({
              rows,
              headers,
              getHeaderProps,
              getRowProps,
              getTableProps,
              onInputChange
            }) => (
              <TableContainer>
                <RadioButtonGroup legendText={<p><strong>Select</strong></p>} name="select-radio-button" defaultSelected="radio-1">
                  <RadioButton labelText="All Registers" onClick={() => loadTable("ALL")} value="radio-1" id="allregisters" />
                  <RadioButton labelText="Errors" onClick={() => loadTable("ERR")} value="radio-2" id="errors" />
                  <Button className="style-bttSelectDate" onClick={() => openModal()} size="md">Select Date</Button>
                </RadioButtonGroup>
                <TableToolbar>
                  <TableToolbarContent>
                    <TableToolbarSearch persistent size="sm" onChange={onInputChange} />
                  </TableToolbarContent>
                </TableToolbar>
                <Table {...getTableProps()} useZebraStyles>
                  <TableHead>
                    <TableRow>
                      {headers.map(header => (
                        <TableHeader {...getHeaderProps({ header })}>
                          {header.header}
                        </TableHeader>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.slice((page - 1) * pageSize).slice(0, pageSize).map((row, i) => (
                      <> {row.cells[3].value.trim() === "Error" && !onlyErrors ? (
                        <TableRow {...getRowProps({ row })}>
                          {row.cells.map(cell => (
                            <>
                              {cell.value.includes("<b>") ? (
                                <TableCell key={cell.id}> <p className={"style_row_error_desc"}> <strong>{cleanDescription(cell.value)}</strong></p> </TableCell>
                              ) : (
                                <TableCell key={cell.id}> <p className={"style_row_error"}>{cell.value}</p> </TableCell>
                              )}

                            </>
                          ))}
                        </TableRow>

                      ) : ( onlyErrors ? (
                        <TableRow {...getRowProps({ row })}>
                          {row.cells.map(cell => (
                            <>
                              {cell.value.includes("<b>") ? (
                                <TableCell key={cell.id}> <p className={"style_row_error_desc2"}> <strong>{cleanDescription(cell.value)}</strong></p> </TableCell>
                              ) : (
                                <TableCell key={cell.id}> <p className={"style_row_error2"}>{cell.value}</p> </TableCell>
                              )}

                            </>
                          ))}
                        </TableRow>
                      ) : ( <TableRow {...getRowProps({ row })}>
                      {row.cells.map(cell => (
                        <>
                          {cell.id.includes("action") ? (
                            <TableCell key={cell.id}><p className={"style_column_action"} >{cell.value}</p></TableCell>

                          ) : (
                            <TableCell key={cell.id}><p className={"style_column_other"}>{cell.value}</p></TableCell>

                          )}
                        </>
                      ))}
                    </TableRow>)
                       
                      )}
                      </>
                    ))}
                  </TableBody>
                </Table>
                <Pagination
                  onChange={changePaginationState}
                  backwardText="Previous page"
                  forwardText="Next page"
                  itemsPerPageText="Items per page:"
                  page={page}
                  pageNumberText="Page Number"
                  pageSize={pageSize}
                  pageSizes={[
                    10,
                    25,
                    50,
                    100,
                  ]}
                  totalItems={rows.length}
                />
              </TableContainer>
            )}
          />
        </Column>
      </Grid>
    </>
  );
};

export default OperationsLog;